@if (loadingState() === 'loading') {
  <p class="text-sm text-secondary m-0 p-4">Loading brand…</p>
} @else if (loadingState() === 'error') {
  <p class="text-sm text-red-600 m-0 p-4" role="alert">Failed to load brand.</p>
} @else if (brand(); as b) {
  <div
    class="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden rounded-xl border border-zinc-200 shadow-sm dark:border-zinc-800 h-full">
    <div class="shrink-0 px-2 py-2 flex flex-row items-center justify-between drawer-header-primary">
      <div class="flex items-center gap-x-4 min-w-0">
        <div class="shrink-0 size-10 overflow-hidden rounded-full">
          <img [src]="imageService.getImageSource(b.companyLogo, 'gallery')" alt="" class="size-full object-cover" />
        </div>
        <div class="min-w-0">
          <h3 class="text-base font-semibold text-gray-900 dark:text-white m-0 truncate">{{ b.companyName }}</h3>
          <p class="text-sm text-gray-500 dark:text-gray-400 m-0 truncate">{{ b.id }}</p>
        </div>
      </div>

      <nav aria-label="Brand insight sections" class="flex flex-row justify-end gap-x-2 shrink-0 overflow-x-auto">
        @for (item of navItems; track item.section) {
          <button type="button"
            class="group inline-flex items-center border-b-2 px-1 py-2.5 text-sm font-medium transition-all duration-200 ease-in-out overflow-hidden cursor-pointer bg-transparent"
            [class]="getNavClass(item)" (click)="goToSection(item)">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="size-4 shrink-0 transition-all duration-200 ease-in-out group-hover:mr-1.5"
              [class]="getNavIconClass(item)" aria-hidden="true">
              @switch (item.section) {
                @case ('profile') {
                  <path d="M10 12h4" />
                  <path d="M10 8h4" />
                  <path d="M14 21v-3a2 2 0 0 0-4 0v3" />
                  <path d="M6 10H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2" />
                  <path d="M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16" />
                }
                @case ('billing') {
                  <path d="M12 18H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5" />
                  <path d="M18 12h.01" />
                  <path d="M19 22v-6" />
                  <path d="m22 19-3-3-3 3" />
                  <path d="M6 12h.01" />
                  <circle cx="12" cy="12" r="2" />
                }
                @case ('team') {
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                  <path d="M16 3.128a4 4 0 0 1 0 7.744" />
                  <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                  <circle cx="9" cy="7" r="4" />
                }
                @case ('visits') {
                  <path d="M3 7V5a2 2 0 0 1 2-2h2" />
                  <path d="M17 3h2a2 2 0 0 1 2 2v2" />
                  <path d="M21 17v2a2 2 0 0 1-2 2h-2" />
                  <path d="M7 21H5a2 2 0 0 1-2-2v-2" />
                  <path d="M8 14s1.5 2 4 2 4-2 4-2" />
                  <path d="M9 9h.01" />
                  <path d="M15 9h.01" />
                }
                @case ('pricing_models') {
                  <path d="M3 3v16a2 2 0 0 0 2 2h16" />
                  <path
                    d="M7 11.207a.5.5 0 0 1 .146-.353l2-2a.5.5 0 0 1 .708 0l3.292 3.292a.5.5 0 0 0 .708 0l4.292-4.292a.5.5 0 0 1 .854.353V16a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1z" />
                }
                @case ('affiliate') {
                  <circle cx="8" cy="21" r="1" />
                  <circle cx="19" cy="21" r="1" />
                  <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
                }
                @case ('appless') {
                  <path d="M12 3H4a2 2 0 0 0-2 2v16.286a.71.71 0 0 0 1.212.502l2.202-2.202A2 2 0 0 1 6.828 19H20a2 2 0 0 0 2-2v-4" />
                  <path d="M16 3h6v6" />
                  <path d="m16 9 6-6" />
                }
              }
            </svg>
            <span class="transition-all duration-200 ease-in-out whitespace-nowrap"
              [class]="activeSection() === item.section ? 'opacity-100 max-w-xs' : 'opacity-0 max-w-0 group-hover:opacity-100 group-hover:max-w-xs'">
              {{ item.label }}
            </span>
          </button>
        }
      </nav>
    </div>

    <div class="brand-insights-outlet-host p-2 scrollbar-transparent">
      <router-outlet />
    </div>
  </div>
}
